import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
export default function AuthCallback() {
    const { login, loading, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        login();
    }, [login]);
    useEffect(() => {
        if (!loading) {
            if (window.opener) {
                window.opener.postMessage({ type: 'SSO_SUCCESS' }, window.location.origin);
                window.close();
                return;
            }
            if (isAuthenticated) {
                navigate('/', { replace: true });
            }
            else {
                navigate('/login', { replace: true });
            }
        }
    }, [loading, isAuthenticated, navigate]);
    return (_jsx("div", { className: "min-h-screen flex items-center justify-center", children: _jsx("p", { className: "text-slate-400", children: "Completing sign-in\u2026" }) }));
}
